export const DownloadIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      opacity="0.3"
      d="M4.88111 1.66797H11.4472C11.7427 1.66797 12.0287 1.77271 12.2544 1.96359L16.2241 5.32125C16.5049 5.55876 16.6668 5.90787 16.6668 6.27564V16.7374C16.6668 18.2295 16.6498 18.3346 15.1192 18.3346H4.88111C3.35054 18.3346 3.3335 18.2295 3.3335 16.7374V3.26519C3.3335 1.77307 3.35054 1.66797 4.88111 1.66797Z"
      fill="#2563EB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.406 9.85926H10.7756V8.1862C10.7756 7.95608 10.5891 7.76953 10.359 7.76953H9.5062C9.27609 7.76953 9.08954 7.95608 9.08954 8.1862V9.85926H7.45915C7.22903 9.85926 7.04248 10.0458 7.04248 10.2759C7.04248 10.3745 7.07744 10.4699 7.14115 10.5452L9.61458 13.4665C9.76328 13.6422 10.0262 13.664 10.2018 13.5153C10.2194 13.5004 10.2357 13.4841 10.2506 13.4665L12.724 10.5452C12.8727 10.3695 12.8509 10.1066 12.6752 9.95793C12.6 9.89422 12.5046 9.85926 12.406 9.85926Z"
      fill="#2563EB"
    />
  </svg>
);
